import { useEffect, useState } from "react";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "今日更新", href: "#updates" },
  { label: "热门追更", href: "#ranking" },
  { label: "分类浏览", href: "#genres" },
  { label: "追更提醒", href: "#feature" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-background-50/95 backdrop-blur border-b border-background-200" : "bg-transparent"
      }`}
    >
      <nav className="mx-auto max-w-7xl px-4 md:px-6 h-16 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2 cursor-pointer">
          <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg font-bold font-heading">韩</span>
          <span className={`font-heading text-lg md:text-xl ${scrolled ? "text-foreground-900" : "text-white"}`}>韩国漫画yy</span>
        </a>

        <div className={`hidden md:flex items-center gap-1 ${scrolled ? "text-foreground-700" : "text-white/90"}`}>
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="px-3 py-2 text-sm whitespace-nowrap rounded-md hover:bg-background-200/50 hover:text-primary-600 transition-colors"
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className={`hidden sm:inline-flex items-center whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium cursor-pointer transition-colors ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "bg-background-50/90 text-primary-700 hover:bg-white"
            }`}
          >
            开启追更提醒
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen(!open)}
            className={`md:hidden w-10 h-10 rounded-md flex items-center justify-center text-xl transition-colors ${
              scrolled ? "text-foreground-900 bg-background-100" : "text-white bg-white/10"
            }`}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-t border-background-200 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="px-3 py-2.5 text-sm text-foreground-800 rounded-md hover:bg-background-100"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#subscribe"
            onClick={() => setOpen(false)}
            className="mt-1 px-3 py-2.5 text-sm font-medium text-center bg-primary-500 text-background-50 rounded-md"
          >
            开启追更提醒
          </a>
        </div>
      )}
    </header>
  );
}